import styled from "styled-components";

export const DetailsContainer = styled.div`
  padding: 20px;
`;

export const VehicleInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

export const EventDetail = styled.div`
  margin-top: 10px;
`;
